// vendor modules
import React, { useEffect, useRef } from "react"
import { connect } from "react-redux"
import { fromJS } from "immutable"
import withImmutablePropsToJS from "with-immutable-props-to-js"
import PropTypes from "prop-types"
import { useOnClickOutside } from "app/static/frontend/imports/hooks"

// components
import Position from "app/static/frontend/components/PositionAdder"

// redux
import { loadProfileAlignment, postProfileAlignment, removeProfileAlignment } from "shared/stakeholder/action-creators"
import { alignmentAdderConnection } from "shared/stakeholder/selectors"

export const AlignmentAdder = (props) => {
    const alignmentAdderRef = useRef()
    useOnClickOutside(alignmentAdderRef, () => {
        props.handleClickOutside()
    })

    useEffect(() => {
        props.loadProfileAlignment({ qdt: props.dataType, profileId: props.profileId })
    }, [props.profileId])

    const updateAlignment = (alignmentTypeId) =>
        props.currentAlignmentTypeId !== alignmentTypeId
            ? props.postProfileAlignment({
                  qdt: props.dataType,
                  profileId: props.profileId,
                  alignmentTypeId,
              })
            : props.removeProfileAlignment({
                  qdt: props.dataType,
                  profileId: props.profileId,
              })

    return (
        <Position
            title="Set Alignment"
            position={fromJS(props.alignmentTypes.find((type) => type.id === props.currentAlignmentTypeId) || {})}
            value={!props.isLoading && props.currentAlignmentTypeId}
            key={props.profileId}
            inline={props.inline}
            isLoading={props.isLoading}
            onValueChange={(itemValue) => updateAlignment(itemValue)}
            choices={props.alignmentTypes}
            alignmentAdderRef={alignmentAdderRef}
        />
    )
}

AlignmentAdder.propTypes = {
    alignmentTypes: PropTypes.object,
    handleClickOutside: PropTypes.func,
    currentAlignmentTypeId: PropTypes.number,
    dataType: PropTypes.number,
    inline: PropTypes.func,
    isLoading: PropTypes.func,
    loadProfileAlignment: PropTypes.func,
    postProfileAlignment: PropTypes.func,
    profileId: PropTypes.number,
}

const UnconnectedAlignmentAdder = withImmutablePropsToJS(AlignmentAdder)

export default connect(alignmentAdderConnection, {
    loadProfileAlignment,
    postProfileAlignment,
    removeProfileAlignment,
})(UnconnectedAlignmentAdder)
